import React, { ChangeEvent } from 'react';

import { SelectedServiceHeader } from 'components/OnlineBooking/components/SelectedServiceHeader';

import { TroubleShootingInput } from './TroubleShootingInput';

export interface Props {
  question?: string | null;
  questionKey: 'question1' | 'question2';
  dataTestId: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const TroubleShootingStep = ({ question, questionKey, dataTestId, onChange }: Props) => {
  return (
    <>
      <SelectedServiceHeader />
      {question && (
        <TroubleShootingInput
          onChange={onChange}
          question={question}
          questionKey={questionKey}
          dataTestId={dataTestId}
        />
      )}
    </>
  );
};
